import script from "./MainBody.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBody.vue?vue&type=script&setup=true&lang=js"

import "./MainBody.vue?vue&type=style&index=0&id=13294f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13294f3e"]])

export default __exports__